import { combineReducers } from "redux";
import goals from "./players/goals";
import numberInTeam from "./players/numberInTeam";
import value from "./players/value";

export default combineReducers({
    goals,
    numberInTeam,
    value,
});



// WEBPACK FOOTER //
// ./src/reducers/app/statistics/players.js